import { ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';
import { Table } from 'components/Display/Table/Table';
import { Button } from 'components/Form/Button';

type EmptyStateProps = {
  children: ReactNode;
  cols: number;
  background?: 'white' | 'gray';
  cta?: Omit<Parameters<typeof Button>[0], 'variant' | 'className'>;
  footnote?: ReactNode;
};

export const EmptyState = ({ children, cols, cta, background = 'white', footnote }: EmptyStateProps) => {
  return (
    <Table.Row withBottomBorder={background === 'white'}>
      <Table.Cell colSpan={cols} className="p-0!">
        <div
          className={cn(
            'py-6 text-center text-sm font-normal text-gray-500!',
            background === 'gray' ? 'bg-gray-50' : undefined,
          )}
        >
          <div className="mx-auto max-w-2xl text-balance">{children}</div>
          {cta ? <Button {...cta} variant="secondary" className="mt-3" /> : null}
          {footnote ? <div className="mt-6 text-xs">{footnote}</div> : null}
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
